export default __webpack_public_path__ + "static/media/rusbath1.2dfae31d.jpeg";